import { Pipe, PipeTransform } from '@angular/core';
import { RoadOccupationTypeAppEntityDictionaryRoadOccupationType } from '../../../../../../openapi';

@Pipe({
  name: 'occupationType',
  standalone: true
})
export class OccupationTypePipe implements PipeTransform {

  constructor() {
  }

  public transform(id?: string, roadOccupationTypes?: RoadOccupationTypeAppEntityDictionaryRoadOccupationType[]): string {
    return roadOccupationTypes?.filter(v => v?.id === id)[0]?.name || id || '-';
  }

}
